module.exports = __webpack_public_path__ + "static/media/xray-compliance.00323d0f.svg";